import {} from 'react';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const SalesIcon = () => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3595 0.799988V2.75019H17.9195L7.68244 13.0158L0.799988 6.14827V8.93251L7.68244 15.8L19.2521 4.19811V6.65365H21.2V0.799988H15.3595Z"
      fill="#2DD28D"
    />
    <rect x="17.6" y="8.59998" width="3.6" height="14.4" rx="1" fill={COLOR_TEXT_MAIN} />
    <rect x="12.2" y="13.4" width="3.6" height="9.6" rx="1" fill={COLOR_TEXT_MAIN} />
    <rect x="6.20001" y="18.8" width="3.6" height="4.2" rx="1" fill={COLOR_TEXT_MAIN} />
    <rect x="0.799988" y="16.4" width="3.6" height="6.6" rx="1" fill={COLOR_TEXT_MAIN} />
  </svg>
);

export default SalesIcon;
